import { Route } from "wouter";
import { Suspense } from "react";
import { RouteComponentProps } from "wouter";

interface PublicRouteProps {
  path: string;
  component: React.ComponentType<RouteComponentProps>;
}

export function PublicRoute({ component: Component, ...rest }: PublicRouteProps) {
  return (
    <Route
      {...rest}
      component={(props) => (
        <Suspense fallback={null}>
          <Component {...props} />
        </Suspense>
      )}
    />
  );
}